import { logAnalyticsEvent } from "@/constants/amplitude";
import { WebEventTypes } from "@/constants/event";

// Needs to resolve "TypeError: Failed to fetch dynamically imported module". See GW-104.
export const addReloadingListener = () => {
    window.addEventListener("vite:preloadError", () => {
        window.location.reload();
    });
};

/**
 * Track when user manually refreshes the page in the browser
 * This detects refreshes via F5, Ctrl/Cmd+R, or browser refresh button
 * Sends events to Amplitude and Telemetry (PaltaDataPlatform)
 */
export const trackPageRefresh = () => {
    if (typeof window === "undefined" || typeof performance === "undefined") {
        return;
    }

    try {
        // Use Navigation Timing API Level 2 (preferred, modern browsers)
        const navigationEntries =
            typeof performance.getEntriesByType === "function"
                ? (performance.getEntriesByType("navigation") as PerformanceNavigationTiming[])
                : [];

        if (navigationEntries.length > 0) {
            const navigationType = navigationEntries[0].type;
            // 'reload' type indicates a manual page refresh
            if (navigationType === "reload") {
                logAnalyticsEvent(WebEventTypes.PAGE_REFRESH);
            }
        } else {
            // Fallback to deprecated performance.navigation (for older browsers)
            // performance.navigation.type === 1 means reload
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const navigation = (performance as any).navigation;
            if (navigation && navigation.type === 1) {
                logAnalyticsEvent(WebEventTypes.PAGE_REFRESH);
            }
        }
    } catch (error) {
        // Send error event to analytics
        const errorMessage = error instanceof Error ? error.message : String(error);
        logAnalyticsEvent(WebEventTypes.ERROR_EVENT, {
            error_source: "trackPageRefresh",
            error_message: errorMessage,
        });
    }
};
